import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, replaceTokensInString } from '../../../utils';
import useHelpCenterLink from '@app/components/pages/csr-landing/hooks/useHelpCenterLink';
import endpoints from '@app/constants/endpoints';
import { CatButton } from '@blocks-react/components/Button';

const ExceptionBlocksFeedbackActions = ({
  showContactUs = false,
  showRefresh = false,
  actions,
  referenceId
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const catalogId = useSelector(state => state?.common.catalogId);
  const storeId = useSelector(state => state?.common.storeId);
  const langId = useSelector(state => state?.common.langId);
  const isHelpCenterEnabledFlag = useSelector(
    s => s.featureFlag?.PCCCustomerSupportHelpCenter
  );
  const isCatCorp = useSelector(s => s.common?.isCatCorp);
  const esiteURL = useSelector(s => s.common?.esiteURL);
  const showHelpCenterPage = isCatCorp || isHelpCenterEnabledFlag;
  const { getHelpCenterContactSupportURL } = useHelpCenterLink();
  const PCCContactUsPageLink = replaceTokensInString(
    endpoints.CONTACT_US_DEALER,
    catalogId,
    langId,
    storeId
  );

  const contactUsPageLink = showHelpCenterPage
    ? getHelpCenterContactSupportURL()
    : `${esiteURL}${PCCContactUsPageLink}`;

  const handleContactUsClick = () => {
    if (showHelpCenterPage) {
      window.open(contactUsPageLink, '_blank');
    } else if (catalogId && storeId && langId) {
      const pageTitle = document.title;
      sessionStorage.setItem('referenceId', referenceId);
      sessionStorage.setItem('pageTitle', pageTitle);
      window.location.href = `CATContactUsDisplayView?catalogId=${catalogId}&langId=${langId}&storeId=${storeId}`;
    }
  };

  const handleRefreshClick = () => {
    window.location.reload();
  };

  const getCallToAction = ({ buttonText, action, disabled = false }, index) => (
    <CatButton
      key={index}
      className="me-2"
      onClick={() => dispatch(action)}
      disabled={disabled}
    >
      {t(buttonText)}
    </CatButton>
  );

  return (
    <div className={'d-flex gap-2'}>
      {!isEmpty(actions) && (
        <div className="text-start">{actions.map(getCallToAction)}</div>
      )}

      {showRefresh && (
        <div className="text-start">
          <CatButton key="refresh" onClick={handleRefreshClick}>
            {t('REFRESH')}
          </CatButton>
        </div>
      )}

      {showContactUs && (
        <div className="text-start">
          <CatButton
            key="contact-us"
            variant="ghost"
            onClick={handleContactUsClick}
          >
            {t('FOOTER_CONTACT_US')}
          </CatButton>
        </div>
      )}
    </div>
  );
};

ExceptionBlocksFeedbackActions.propTypes = {
  showContactUs: PropTypes.bool,
  showRefresh: PropTypes.bool,
  referenceId: PropTypes.string,
  actions: PropTypes.array
};

export default ExceptionBlocksFeedbackActions;
